import UserNotification from "util/UserNotification";
export const handleFailures = (failures = [], actionPastTense = "submitted") => {
  if (failures.length) {
    UserNotification.error(`Data Lake could not be ${actionPastTense}.`);
  } else {
    UserNotification.success(`Data Lake was ${actionPastTense} successfully.`, "Success");
  }
};
